<template>
    <text-dialog :value.sync="dialog" :title="title">
        <slot slot="activator" name="activator"></slot>
        <div slot="content">
            <h3 v-text="trans.key"></h3>
            <v-textarea v-model="trans.de" label="Deutsch" required></v-textarea>
            <v-textarea v-model="trans.en" label="Englisch" required></v-textarea>
            <div class="right">
                <v-btn v-t="'cancel'" @click="cancel" flat></v-btn>
                <v-btn color="primary" @click="submit" v-t="'ok'"></v-btn>
            </div>
        </div>
    </text-dialog>
</template>

<script>
    import TextDialog from '../dialogs/TextDialog';

    export default {
        components: {
            'text-dialog': TextDialog
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            translation: {
                type: Object,
                default: null
            },
            text: {
                type: String,
                default: ''
            },
            value: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            dialog: false,
            trans: {
                de: '',
                en: '',
                key: ''
            }
        }),
        watch: {
            value() {
                this.dialog = this.value;

                if (this.dialog) {
                    this.trans = _.cloneDeep(this.translation);
                }
            },
            dialog() {
                this.$emit('update:value', this.dialog);
            }
        },
        mounted() {
            this.dialog = this.value;
            this.trans = _.cloneDeep(this.translation);
        },
        methods: {
            submit() {
                axios.post('/api/v1/i18n/translations', this.trans).then(response => {

                    if (!response.data.success) {
                        this.$store.commit('snackBar', {
                            color: 'error',
                            text: 'Übersetzung konnte nicht gespeichert werden'
                        });
                        return;
                    }

                    //this.loading = false;

                    this.$emit('ok', this.trans);

                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: 'Übersetzung gespeichert'
                    });
                }, errorResponse => {
                    console.log(errorResponse);
                    this.loading = false;
                });
                this.dialog = false;
            },
            cancel() {
                this.$emit('cancel');
                this.dialog = false;
            }
        }
    }
</script>